const CONTROL_ACCESO_PERMISS_LIST = (state, listpermiss) => {
  if (listpermiss.code === 1) {
    state.controlaccesopermiss = listpermiss.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}

const CONTROL_ACCESO_PERMISS_LIST_CREAR = (state, listpermiss) => {
  if (listpermiss.code === 1) {
    state.controlaccesopermiss = listpermiss.data
    state.status = 'success'
  } else {
    alert(listpermiss.message)
    state.status = 'error'
  }
}

export default {
  CONTROL_ACCESO_PERMISS_LIST,
  CONTROL_ACCESO_PERMISS_LIST_CREAR
}



// WEBPACK FOOTER //
// ./src/store/modules/controlacceso/permiss/mutations.js